import { createSafeContext } from '@mantine/utils';

const [ListProvider, useListContext] = createSafeContext("List component was not found in tree");

export { ListProvider, useListContext };
//# sourceMappingURL=List.context.js.map
